module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_03-f322ae602c80a0f0124cdf84e5ca5a4a.png";